import type {State} from 'src/reducers';
import type {
  JobVariables,
  JobVariablesMap,
  JobVariableValues,
  JobVariableValue,
} from 'src/types/job-variables';

import {createSelector} from 'reselect';

/*
 * Base Selectors
 */

export const selectJobVariables = (state: State): JobVariables =>
  state.jobVariables.variables || [];

export const selectJobVariableMap: (state: State) => JobVariablesMap =
  createSelector(selectJobVariables, (jobVariables) =>
    jobVariables.reduce((acc, variable) => {
      acc.set(variable.name, variable);
      return acc;
    }, new Map()),
  );

export const selectJobVariableValues = (state: State): JobVariableValues =>
  state.jobVariables.variableValues || {};

// @ts-expect-error - TS2322 - Type 'OutputSelector<any, { name: string; index: number; value: any; apiKey: string; }[], (res: JobVariableValues) => { name: string; index: number; value: any; apiKey: string; }[]>' is not assignable to type '(state: any) => JobVariableValue[]'.
export const selectJobVariableValuesList: (state: State) => JobVariableValue[] =
  createSelector(selectJobVariableValues, (jobVariableValues) =>
    /** api response is of the form {matched_job/location/0:bangalore,matched_job/location/1:hyderabad}
     * normalize it to the form [{name:matched_job/location,value:bangalore,index:0}] to be used on the ui
     */
    Object.keys(jobVariableValues)
      .map((key) => {
        const keyArr = key.split('/');
        const index = keyArr.pop();
        const name = keyArr.join('/');
        return {
          name,
          // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
          index: parseInt(index, 10),
          value: jobVariableValues[key],
          apiKey: key,
        };
      })
      .sort((a, b) => a.index - b.index),
  );
